import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import NumberFormat from "react-number-format";
import { useForm, Controller } from "react-hook-form";
import api from "services/api";

import { Card } from "@mui/material";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

import { capitalCase } from "capital-case";
import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import { accountTypeOptions } from "utils/data";
import CreateInviteCodeModal from "pages/admin/invite-code/components/CreateInviteCodeModal";

const InviteCodes = () => {
  const [data, setData] = useState([]);
  const [createVisible, setCreateVisible] = useState(false);

  const [selectedInviteCode, setSelectedInviteCode] = useState(null);
  const [deleteInviteCodeVisible, setDeleteInviteCodeVisible] = useState(false);
  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    retrieveInviteCodes();
  }, []);

  const retrieveInviteCodes = async () => {
    try {
      const { data } = await api.invitecode.list();
      setData(data?.invites ? data.invites : []);
    } catch (err) {
      console.log(err);
    }
  };
  const formatAccountType = (type) => {
    const option = accountTypeOptions.find((x) => x.value == type);
    return option ? option.label : type;
  };

  const getProjectTableRow = (item) => {
    const actions = [
      {
        label: (
          <SuiTypography variant="body" color="error">
            Delete Code
          </SuiTypography>
        ),
        onClick: () => {
          setSelectedInviteCode(item);
          setDeleteInviteCodeVisible(true);
        },
        icon: <DeleteForeverRoundedIcon fontSize={"small"} />,
      },
    ];

    return {
      key: item.id,
      code: item.code,
      account_type: formatAccountType(item.account_type),
      progress: item.accepted_count + "/" + item.count,
      created_at: item.created_at,
      expires_at: item.expires_at,
      action: <Actionables actions={actions} />,
    };
  };

  const columns = [
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "Account Type",
      accessor: "account_type",
    },
    {
      Header: "Progress",
      accessor: "progress",
    },
    {
      Header: "Create At",
      accessor: "created_at",
      Cell: ({ row, value }) => {
        return <div>{moment(value).format("YYYY-MM-DD HH:mm:ss")}</div>;
      },
    },
    {
      Header: "Expires At",
      accessor: "expires_at",
      Cell: ({ row, value }) => {
        return <div>{value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : ""}</div>;
      },
    },
    { Header: "More", accessor: "action" },
  ];

  const rows = data.map((item) => getProjectTableRow(item));

  return (
    <Card sx={{ p: 3 }}>
      <SuiBox display="flex" justifyContent="end" alignItems="flex-end">
        <div>
          <SuiButton
            variant="contained"
            color="white"
            sx={{ height: "100%" }}
            onClick={() => {
              setCreateVisible(true);
            }}
          >
            Create
          </SuiButton>
        </div>
      </SuiBox>

      <DataTable
        table={{ columns, rows: rows }}
        entriesPerPage={{ defaultValue: 20 }}
        noEndBorder
      />
      {/**Create new Invite Code*/}
      {createVisible ? (
        <CreateInviteCodeModal
          visible={createVisible}
          handleClose={() => {
            retrieveInviteCodes();
            setCreateVisible(false);
          }}
        />
      ) : null}
      {/**Delete invite code */}
      {selectedInviteCode && deleteInviteCodeVisible ? (
        <Prompt
          heading="Delete Invite Code"
          text={`Are you sure you want to delete the invite code: ${selectedInviteCode.code}`}
          visible={deleteInviteCodeVisible}
          okText="Delete"
          okColor="error"
          handleOk={() =>
            api.invitecode
              .delete(selectedInviteCode.id)
              .then(() => {
                toast.success(`Delete invite code ${selectedInviteCode.code} successfully!`);
                if (data) {
                  const newData = data.filter((x) => x.id != selectedInviteCode.id);
                  setData(newData);
                }
                setDeleteInviteCodeVisible(false);
              })
              .catch((err) => {
                console.log(err);
                toast.error(`Delete invite code ${selectedInviteCode.code} failed!`);
              })
          }
          handleClose={() => setDeleteInviteCodeVisible(false)}
        />
      ) : null}
    </Card>
  );
};

export default InviteCodes;
